<template>
  <div class="element-box h-100 text-center my-auto">
    <template v-if="quickLink">
      <div class="quicklink-div" @click="quickRedirect(quickLink.item_name)">
        <div class="col-12">
         <span class="d-inline-block align-middle">
           <i class="os-icon quicklink-icon text-primary" :class="quickLink.navbar_icon ? quickLink.navbar_icon : 'os-icon-book-open'"></i>
         </span>
        </div>
        <div class="col-12">
          <span class="d-inline-block align-middle">{{t(quickLink.item_key, quickLink.item_key)}}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="element-box h-100 text-center my-auto">
        <div class="col-12">
          <span class="d-inline-block align-middle">
            <i class="os-icon quicklink-icon os-icon-x text-danger"></i>
          </span>
        </div>
        <div class="col-12">
          <span class="d-inline-block align-middle">N/A</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'UserQuickLink',
  props: ['link'],
  data() {
    return {
      quickLink: this.link,
    }
  },
  methods: {
    quickRedirect(link) {
      this.$router.push({ name: link})
    }
  },
}
</script>

<style scoped>
  .quicklink-div {
    cursor: pointer;
  }

  .quicklink-icon {
    font-size:2.95rem;
  }
</style>
